import React from 'react';
import { motion } from 'framer-motion';
import { Diamond } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'La Receta Maestra del Bizcocho Terciopelo',
    desc: 'Una base húmeda que soporta el peso del tesoro sin desmoronarse.'
  }, {
    title: 'Técnica del Corazón Esmeralda',
    desc: 'El equilibrio exacto de pistacho y sal para un sabor premium.'
  }, {
    title: 'El Protocolo de Tostado 3-2-1',
    desc: 'La guía paso a paso para el crujiente perfecto que suena como en los videos.'
  }, {
    title: 'Guía de Sustitutos de Supermercado',
    desc: 'Mi lista secreta para ahorrar dinero sin sacrificar el estatus.'
  }, {
    title: 'Checklist de Ensamblaje de Diamante',
    desc: 'Para un acabado visual digno de una vitrina de lujo.'
  }];
  return <section className="py-24 px-6 bg-dark-lighter" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-162">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-4" data-id="element-163">
            Lo que obtienes hoy
          </h2>
          <div className="h-1 w-20 bg-gold mx-auto" data-id="element-164"></div>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-165">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className={`bg-dark p-8 rounded-lg border border-gold/10 hover:border-gold/30 transition-colors ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-166">
              <Diamond className="w-8 h-8 text-gold mb-6" strokeWidth={1.5} data-id="element-167" />
              <h3 className="font-serif text-xl text-cream mb-3" data-id="element-168">
                {item.title}
              </h3>
              <p className="font-sans text-cream-muted text-sm leading-relaxed" data-id="element-169">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}